import Select from './component';

export default Select;
